// extracted by mini-css-extract-plugin
module.exports = {"title":"reservationclean_title__3LelI","mainDiv":"reservationclean_mainDiv__9Wlzm","questionDiv":"reservationclean_questionDiv__3PC02"};